import { createTableApi } from '~/api/utils/create-table-api';

export const blocks = {
  ...createTableApi('/blocks')
};
